import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack
} from '@mui/material';

const AddParagraphDialog = ({ open, onClose, onAdd, position }) => {
  const [heading, setHeading] = useState('');
  const [plan, setPlan] = useState('');
  
  const handleSubmit = () => {
    onAdd({
      heading,
      plan,
      order: position
    });
    setHeading('');
    setPlan('');
  };
  
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add New Paragraph</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            label="Heading"
            fullWidth
            value={heading}
            onChange={(e) => setHeading(e.target.value)}
            required
          />
          <TextField
            label="Plan/Notes (optional)"
            fullWidth
            multiline
            rows={4}
            value={plan}
            onChange={(e) => setPlan(e.target.value)}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button 
          onClick={handleSubmit} 
          variant="contained"
          disabled={!heading.trim()}
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddParagraphDialog;
